import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { PageContainer, MainContainer } from '../../ui';
import { ArbiWinHeader, ArbiWinFooter } from '../../ui';
import ResetPasswordForm from './ResetPasswordForm';

/**
 * ResetPasswordPage component - Page for resetting password with token
 * @returns {JSX.Element} ResetPasswordPage component
 */
const ResetPasswordPage = function ResetPasswordPage() {
  const navigate = useNavigate();
  const { token: pathToken } = useParams();
  const location = useLocation();
  
  // Get token from either path parameter or query parameter
  const searchParams = new URLSearchParams(location.search);
  const queryToken = searchParams.get('token');
  const token = pathToken || queryToken;
  
  return (
    <PageContainer>
      <ArbiWinHeader 
        isAuthenticated={false}
        onLogin={() => navigate('/login')}
        onRegister={() => navigate('/register')}
        onHomeClick={() => navigate('/')}
      />
      <MainContainer>
        <div style={{ maxWidth: 480, margin: '0 auto', padding: 'var(--spacing-8) var(--spacing-4)' }}>
          <ResetPasswordForm 
            token={token}
            onBackToLogin={() => navigate('/login')}
          />
        </div>
      </MainContainer>
      <ArbiWinFooter />
    </PageContainer>
  );
};

export default ResetPasswordPage;
